import { FC } from 'react';
import { ITypeBreakdownMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import { DistributionDonut } from '../../../../shared/charts/DistributionDonut';
import { DistributionSlice } from '../../../../shared/charts/chart.types';
import { getPaletteColor } from './_shared/chartPalette';

interface Props {
  data: ITypeBreakdownMetric | null;
  period?: string;
  height?: number;
}

export const TypeBreakdownChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.items || data.items.length === 0) {
    return <ChartEmptyState />;
  }

  const slices: DistributionSlice[] = data.items.map((item, index) => ({
    id: item.type,
    label: item.type,
    value: item.count,
    percent: Math.round(item.pct),
    color: getPaletteColor(index),
  }));

  return <DistributionDonut data={slices} height={height} valueFormatter={(v) => `${v}`} />;
};
